module.exports = __webpack_public_path__ + "img/grab_head_set.41877d93.png";